import * as Immutable from 'immutable';
import { POPUP_OPEN, POPUP_TOGGLE, POPUP_CLOSE, PopupIds } from './popupConstants';
import {
    PopupCloseAction,
    PopupCloseMultipleAction,
    PopupOpenAction,
    PopupPredicateFn,
    PopupToggleAction,
} from './popupActionTypes';

import { ELEMENT_MOVE, ELEMENT_MOVE_AND_UPDATE, ELEMENT_MOVE_MULTI } from '../../../common/elements/elementConstants';

import { DRAG_START } from '../../reducers/draggingConstants';
import { USER_NAVIGATE } from '../../../common/users/userConstants';
import { UnknownAction } from 'redux';

type ActiveState = { predicateFn: PopupPredicateFn; data?: Record<string, unknown> };

const initialState = Immutable.Map<string, ActiveState>();

type ActivePopupsState = Immutable.Map<string, ActiveState>;

const addPopup = (state: ActivePopupsState, { popupId, data, predicateFn }: PopupOpenAction | PopupToggleAction) =>
    state.set(popupId, { data, predicateFn });
const removePopup = (state: ActivePopupsState, { popupId }: PopupOpenAction | PopupCloseAction | PopupToggleAction) =>
    state.delete(popupId);
const removeMultiplePopups = (state: ActivePopupsState, { popupIds }: PopupCloseMultipleAction) =>
    state.withMutations((mutableState) =>
        popupIds.forEach((popupId) => removePopup(mutableState, { popupId } as PopupCloseAction)),
    );

export default (state: ActivePopupsState = initialState, action: UnknownAction) => {
    switch (action.type) {
        // popup actions
        case POPUP_OPEN:
            return addPopup(state, action as unknown as PopupOpenAction);
        case POPUP_TOGGLE:
            if (state.get((action as unknown as PopupToggleAction).popupId))
                return removePopup(state, action as unknown as PopupToggleAction);
            return addPopup(state, action as unknown as PopupToggleAction);
        case POPUP_CLOSE:
            if (action.closeAll) return initialState;
            return action.popupIds
                ? removeMultiplePopups(state, action as unknown as PopupCloseMultipleAction)
                : removePopup(state, action as unknown as PopupCloseAction);
        // close popups on these Actions
        case USER_NAVIGATE:
        case ELEMENT_MOVE:
        case ELEMENT_MOVE_AND_UPDATE:
        case ELEMENT_MOVE_MULTI:
        case DRAG_START:
        case '@@router/LOCATION_CHANGE':
            return state.filter((activeState, key) => {
                // This needs to be explicitly defined here because the popupToggle action is created
                // from the electron main process, and it cannot serialise a predicateFn to the client
                if (key === PopupIds.ELECTRON_UPDATE_REQUIRED) return true;
                if (key === PopupIds.LABELS_TOOL && action.type === ELEMENT_MOVE_MULTI) return true;

                if (activeState?.predicateFn) return activeState?.predicateFn(state, action);

                return false;
            });
        default:
            return state;
    }
};
